// extracted by mini-css-extract-plugin
export var cell = "_5o-4";
export var headerCell = "_5o-2";
export var rowHeader = "_5o-3";
export var table = "_5o-1";
export var tableContainer = "_5o-0";